import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src507617047/src/app/[locale]/(site)/_components/LandingHomePage.tsx");
